import React from 'react';
import { WHATSAPP_LINK } from '@/data/brand';
import { WHATSAPP_FLOAT } from '@/constants/testIds';

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.55 4.07 1.6 5.84L2 22l4.4-1.15a9.84 9.84 0 0 0 5.64 1.78h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.02A9.86 9.86 0 0 0 12.04 2zm5.83 14.04c-.25.69-1.44 1.32-1.99 1.41-.51.08-1.15.11-1.86-.12-.43-.13-.99-.33-1.71-.64-3-1.3-4.96-4.32-5.11-4.52-.15-.2-1.22-1.62-1.22-3.1 0-1.47.77-2.2 1.05-2.5.27-.3.6-.37.8-.37.2 0 .4 0 .58.01.18.01.43-.07.67.51.25.6.86 2.07.94 2.22.08.15.13.33.03.53-.1.2-.15.32-.3.5-.15.18-.32.4-.45.54-.15.15-.3.32-.13.62.18.3.78 1.28 1.67 2.07 1.15 1.02 2.12 1.34 2.42 1.49.3.15.48.13.65-.08.18-.2.75-.87.95-1.17.2-.3.4-.25.67-.15.27.1 1.72.81 2.02.96.3.15.5.22.57.35.07.13.07.74-.18 1.45z"/>
  </svg>
);

export default function WhatsAppFloat({ message = 'Hola Jelly! Quiero saber más 💕' }) {
  return (
    <a
      data-testid={WHATSAPP_FLOAT}
      href={WHATSAPP_LINK(message)}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white inline-flex items-center justify-center shadow-2xl animate-pulse-pink hover:scale-110 transition-transform"
    >
      <WhatsAppIcon className="w-7 h-7" />
    </a>
  );
}
